import { ADDON_WIFI_MESH_CODE } from "@features/cart/components/BroadbandCard/BroadbandCartAddon/constants";
import { ICart, ICartAddon } from "@features/cart/ICart";
import { EServiceGroup } from "@constants";
import { IEirSalesOfferAddon } from "@modules/eirSalesFacade/interfaces/models/IEirSalesOfferAddon";
import { selectOfferInCartByServiceGroup } from "@utils/offerUtils";

export const findWifiMeshOfferAddon = (addonList: IEirSalesOfferAddon[] | undefined): IEirSalesOfferAddon | undefined =>
    addonList?.find((addon) => addon.code === ADDON_WIFI_MESH_CODE);

export const filterWifiMeshCartAddonList = (addonList: ICartAddon[] | undefined): ICartAddon[] | undefined =>
    addonList?.filter((addon) => addon.catalogCode === ADDON_WIFI_MESH_CODE);

export const mapNewCartAddonIdList = (cart: ICart | undefined): number[] => {
    const newAddonList = selectOfferInCartByServiceGroup(cart, EServiceGroup.SA_BB)?.addOns;
    const newAddonListFiltered = filterWifiMeshCartAddonList(newAddonList);

    return newAddonListFiltered?.map((addon) => addon.id) ?? [];
};
